<template>
    <!-- 会员列表 -->
    <div>
        <skeleton-screen-card v-if="!isCloseSkeletonScreen" :data="3" />
        <div v-if="isCloseSkeletonScreen">
            <!-- 列表 -->
            <div v-if="msg_list.length" style="background-color: #F5F6F7;">
                <app-live-list-pub
                    v-for="(item, index) in msg_list"
                    :sourcePage="sourcePage"
                    :pageName="pageName"
                    :key="item.id"
                    :live="teacherInfo"
                    :msg="item"
                    :is_vip="is_vip"
                    :teacherInfo="teacherInfo"
                    :indexItem="index"
                    :view_range_show="view_range_show"
                    :isSelf="isSelf"
                    :forward_vip_content="item.forward_vip_content"
                    :vip_content="item.vip_content"
                    :apptextSize="apptextSize"
                ></app-live-list-pub>
            </div>

            <no-result v-if="!msg_list.length" title="暂无内容~"></no-result>

            <loading-dom
                class="loadbox"
                loadType="small"
                :title="'正在加载中...'"
                v-if="msg_list.length && listLoading"
            ></loading-dom>

            <no-data msg="已经到底了~" v-if="!listLoading && hasMore && msg_list.length"></no-data>
        </div>
    </div>
</template>
<script>
import userHomeApi from "@/api/user_home/index.js";

export default {
    name: "UserProfiles",
    components: {
        appLiveListPub:() => import('@/components/userHome/app-live-list-pub.vue'),
        TopLiveCard: () => import("@/components/userHome/topLiveCard.vue"), // 顶部直播卡片
        noData: () => import("@/components/userHome/components/noData.vue"),
        noResult: () => import("@/components/userHome/components/noResult.vue"),
        loadingDom: ()=> import("@/components/userHome/components/loading.vue"),
        noticeBanner: () => import("@/components/userHome/noticeBanner.vue"),
        skeletonScreenCard: () => import("@/components/userHome/components/skeletonScreen.vue")
    },
    computed: {
        userInfo() {
            return this.$store.state.userProfiles.userInfo;
        }
    },
    props: {
        pageType: {
            type: String,
            default: "teacher"
        },
        pageName: {
            type: String,
            default: "",
        },
        teacherInfo: {
            type: Object,
            default: ()=>{
                return {}
            }
        },
        liveCardInfo: { // 直播卡片信息
            type: Object,
            default: ()=>{
                return {}
            }
        },
        isSelf: {
            type: Boolean,
            default: false
        },
        apptextSize: {
            type: String,
            default: "normal"
        },
        sourcePage: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            user_id: parseInt(this.$route.query.id) || 0,
            l_id: parseInt(this.$route.query.l_id) || 0,
            msg_list: [],
            isCloseSkeletonScreen: false,

            listLoading: false,
            hasMore: false,
            before: 0,
            is_vip: "",
            view_range_show: {},
            view_range_is_show: false,
            separation_time: null,
			
			view_range_info: null,
        };
    },
    created() {
        //获取用户全部数据
        this.init();
        this.getLiverNotice();
    },
    methods: {
        init() {
            //获取用户全部数据
            this.getCenterList();
        },
        columnListMore() {
            if (this.msg_list.length === 0 || this.listLoading || this.hasMore) {
                return
            };

            this.before = this.msg_list[this.msg_list.length - 1].rec_time;

            this.init();
        },
        reloadList() {
            this.before = 0;
            this.msg_list = [];
            //获取用户全部数据
            this.getCenterList('close');
        },
        editItemFn(obj) {
            let {itemIndex, query} = obj;
            if(itemIndex >= 0) {
                for(let item in query) {
                    this.$set(this.msg_list[itemIndex], item, query[item]);
                }
            }
        },
        delItemFn(obj) {
            let {itemIndex} = obj;
            if(itemIndex >= 0) {
                this.msg_list.splice(itemIndex, 1)
            }
        },
        editRSAStr(obj) {
            let {itemIndex, isForward, content} = obj;
            if(itemIndex >= 0) {
                this.$set(this.msg_list[itemIndex], isForward?'forward_vip_content': 'vip_content', content);
            }
        },
        //获取老师个人主页全部直播列表
        async getCenterList(type) {

            if (this.listLoading) {
                return
            }

            this.listLoading = true;

            let params = {
                act: "msg",
                division: 3,
                id: this.l_id,
                before: this.before,
                kind: "vip"
            }
            if(this.sourcePage == "jf") {
                params.from_page = "jf_promotion";
            }
            if(params.before > 0) {
                params.allnumber = 11;
            }
            let centerList = await userHomeApi.getLiveCenter(params);

            if(centerList && centerList.rslt == 'succ') {
                if (centerList.msg_list && centerList.msg_list.length > 0) {
                    let insertData = centerList.msg_list;
                    let normalData = insertData;
                    if (this.before) {
                        this.msg_list = this.msg_list.concat(insertData);
                    } else {
                        if(centerList.top_msg_list && centerList.top_msg_list.length > 0) {
                            insertData.unshift(...centerList.top_msg_list)
                        }
                        this.msg_list = insertData;
                        this.$forceUpdate();
                    }

                    // 判断是否不是全部可见，并且字段存在
                    if(
                        centerList.view_range_show &&
                        centerList.view_range_show.view_range_describe &&
                        centerList.view_range_show.view_range_value != "All"
                    ) {
						this.view_range_info = true;

                        // 没有出现过置顶
                        if(!this.view_range_is_show && centerList.separation_time) {
                            let separation_time = null, view_range_is_show = false,isSave = false,saveId = null;
                            if(!this.before) {
								if(centerList.separation_time) {
									separation_time = new Date(centerList.separation_time.replace(/-/g, '/')).getTime() / 1000;
								}
                            } else {
                                separation_time = this.separation_time;
                            }
                            
                            
                            for(let i=0,ilen=normalData.length;i<ilen;i++) {
                                if(normalData[i].rec_time < separation_time) {
                                    isSave = true;
                                    view_range_is_show = true;
                                    saveId = normalData[i].id;
                                    break;
                                }
                            }

                            this.separation_time = separation_time;

                            if(isSave) {
                                let view_range_show = centerList.view_range_show;
                                view_range_show.separation_time = separation_time
                                view_range_show.saveId = saveId;

                                this.view_range_show = view_range_show;

                                this.view_range_is_show = view_range_is_show;
                            }
                        }
                    }
                    this.is_vip = centerList.is_vip;
                    this.isData(insertData);
                } else {
                    this.hasMore = true;
                }   
            }
            if(type) {
                this.$srH5CallNativeMethodApp('refresh_done',{})
            }
            this.listLoading = false;
            this.isCloseSkeletonScreen = true;
            // this.$emit("scrollRefresh");
        },
        // 获取战绩榜数据
        async getLiverNotice() {
            let res = await userHomeApi.getLiverNotice({
                location: this.tabName == 'TabsEssence'? "essence": "homepage",
                l_id: this.l_id
            })
            if(res.rslt == 'succ') {
                let result = res.data;
                this.noticeList = result;
            }
        },
        isData(data) {
            if (!data.length) {
                this.hasMore = true;
            } else {
                this.hasMore = false;
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.recommend {
    position: fixed;
    overflow: auto;
    top: 48px;
    width: 100%;
    padding-bottom: 50px;
    bottom: 0;
    background-color: #f0f0f0;
}

.recommend-content {
    height: 100%;
    overflow: hidden;
}

.view_range_show {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0 30px;
    box-sizing: border-box;
    background-color: #F5F6F7;

    p {
        color: #939393;
        text-align: center;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        position: relative;

        &::before {
            content: "";
            position: absolute;
            width: 43.5px;
            height: 1px;
            background-color: #EBEBEB;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }

        &::after {
            content: "";
            position: absolute;
            width: 43.5px;
            height: 1px;
            background-color: #EBEBEB;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
</style>